<msf-summary-wrapper
  title="{{isSubmenu?'Administration':'Satellite Images'}}"
  [items]="MENU_ITEMS | menuChildren :
  (this.isSubmenu ? MenuItemType.SatelliteAdministration: MenuItemType.SatelliteData)"
>
  <div
    title
    class="flex align-items-center mb-4">
    <button
      pButton
      type="button"
      icon="pi pi-arrow-left"
      class="p-button-rounded p-button-text p-button-plain mr-2"
      (click)="goBack()"></button>
    <h1 class="m-0 text-color">
      {{ (isSubmenu ? "Administration" : "Satellite Data") | translate }}
    </h1>
  </div>
  <div
    right
    #right
    class="satellite-summary">
    <div class="summary-header">
      <h2 class="summary-title">
        <i class="pi pi-chart-bar mr-2"></i>
        {{ "Summary information" | translate }}
      </h2>
      <button
        pButton
        type="button"
        icon="pi pi-refresh"
        (click)="loadSummaryData()"
        [loading]="loading"
        class="p-button-sm p-button-text"></button>
    </div>
    <div
      *ngIf="loading"
      class="loading-container">
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }"></p-progressSpinner>
      <p class="loading-text">{{ "Loading..." | translate }}</p>
    </div>
    <div
      *ngIf="error"
      class="error-container">
      <p-message
        severity="error"
        [text]="error"
        [closable]="false"
        [style]="{ 'margin-bottom': '1rem' }"></p-message>
      <button
        pButton
        type="button"
        [label]="'Retry' | translate"
        (click)="loadSummaryData()"
        class="p-button-sm p-button-outlined"></button>
    </div>
    <div
      *ngIf="summaryData && !loading && !error"
      class="summary-content">
      <div class="stats-grid">
        <div class="stat-card total">
          <div class="stat-icon"><i class="pi pi-globe"></i></div>
          <div class="stat-content">
            <div class="stat-number">{{ summaryData.totalProducts }}</div>
            <div class="stat-label">{{ "Total Products" | translate }}</div>
          </div>
        </div>
        <div class="stat-card sentinel">
          <div class="stat-icon"><i class="pi pi-satellite"></i></div>
          <div class="stat-content">
            <div class="stat-number">{{ summaryData.sentinel2Count }}</div>
            <div class="stat-label">{{ "Sentinel-2 Products" | translate }}</div>
          </div>
        </div>
        <div class="stat-card landsat">
          <div class="stat-icon"><i class="pi pi-image"></i></div>
          <div class="stat-content">
            <div class="stat-number">{{ summaryData.landsatCount }}</div>
            <div class="stat-label">{{ "Landsat Products" | translate }}</div>
          </div>
        </div>
      </div>
      <div class="last-update-section">
        <div class="update-info">
          <i class="pi pi-clock"></i>
          <span>{{ "Last updated" | translate }}: {{ summaryData.lastUpdateUtc | date: "dd.MM.yyyy HH:mm" }}</span>
        </div>
      </div>
    </div>
  </div>
</msf-summary-wrapper>
